import { color, TZABrandGuidelines } from '@my/util'
import React, { useState } from 'react'
import { YStack, GroupedBarChart, DonutChart, XStack, SimpleText, useMedia } from '@my/ui'
import { valueToMonthData } from '../helpers'
import { ToggleButtonGroup } from '../../../components/index'
import { MonthlyIncomeSpendingDonutChart } from '../snapShot/snapShotChart'

interface props {
  monthlySpendingAlalysisData: []
  monthlyCashFlows: any
}

export const SpendingChart: React.FC<props> = ({ monthlySpendingAlalysisData, monthlyCashFlows }) => {
  const media = useMedia();
  const [worthActivePeriod, setWorthActivePeriod] = useState('3 Months')

  const monthsArray = [0,1,2,3,4,5];
  const barChartData = [
    {
      name: 'Income - Budgeted',
      data: valueToMonthData(() => parseFloat(monthlyCashFlows?.Operating?.Income?.total || 0), monthsArray),
    },
    {
      name: 'Expenses - Budgeted',
      data: valueToMonthData(() => parseFloat(monthlyCashFlows?.Operating?.Expenses?.total || 0), monthsArray),
    },
  ]

  return (
    <XStack
      //flexGrow={1}
      flexWrap="wrap"
      justifyContent="center"
      gap={20}
      style={{width: '100%'}}
      //$platform-web={{ maxWidth: 1000 }}
      $max-sm={{
        flexDirection: 'column',
        justifyContent: 'center'
      }}
    >
      <YStack style={{width: '100%', gap:10, maxWidth: 500}}
        padding={20}
        paddingLeft={30}
        borderWidth={1}
        borderRadius={10}
        borderColor={'rgba(108, 117, 125, 0.44)'}
      >
        <XStack>
          <SimpleText fontSize={15} lineHeight={29} fontWeight={'800'} color={color.lightGrey}>
            Monthly Income & Spending
          </SimpleText>
        </XStack>
        <XStack style={{width: '100%', justifyContent: 'center'}}>
          <GroupedBarChart
            barData={barChartData}
            legendData={[
              { name: 'Income - Budgeted', fill: TZABrandGuidelines.colorsMap.secondaryMustard },
              { name: 'Expenses - Budgeted', fill: TZABrandGuidelines.colorsMap.secondaryBrightBlue },
            ]}
            colorScale={[TZABrandGuidelines.colorsMap.secondaryMustard, TZABrandGuidelines.colorsMap.secondaryBrightBlue]}
          />
        </XStack>
      </YStack>

      <YStack style={{width: '100%', gap:10, maxWidth: 500}}
        padding={20}
        borderWidth={1}
        borderRadius={10}
        borderColor={'rgba(108, 117, 125, 0.44)'}
      >
        <XStack
          flexWrap="wrap"
          justifyContent="space-between"
          gap={10}
          //$platform-native={{ maxWidth: 350 }}
          $platform-web={{ maxWidth: 350 }}
          //maxWidth={350}
        >
          <SimpleText fontSize={15} lineHeight={29} fontWeight={'800'} color={color.lightGrey}>
            Spending Breakdown
          </SimpleText>
          {/* <ToggleButtonGroup active={worthActivePeriod} onChange={setWorthActivePeriod} /> */}
        </XStack>

        <XStack style={{width: '100%', justifyContent: 'center'}}>
          <MonthlyIncomeSpendingDonutChart monthlyCashFlows={monthlyCashFlows} />
        </XStack>
        {/* <DonutChart
          data={worthData}
          legendData={[
            { name: 'Light Red', fill: color.lightRed },
            { name: 'Cyan', fill: color.cyan },
            { name: 'Green', fill: color.tzaGreen },
            { name: 'Sky Blue', fill: color.darkSkyBlue },
          ]}
          colorScale={[color.lightRed, color.cyan, color.tzaGreen, color.darkSkyBlue]}
        /> */}
      </YStack>
    </XStack>
  )
}
